// Header.jsx
import React, { useState, useRef, useContext, useEffect } from 'react';
import stylesDesktop from './Banner.module.css';
import stylesMobile from './BannerMobile.module.css';
import useBreakpoint from 'hooks/useBreakpoint';
import useDesignSettingsData from 'hooks/useDesignSettingsData';

const Banner = (variant) => {
    const isMobile = useBreakpoint();
    // Sélection des styles en fonction du contexte
    const styles = isMobile ? stylesMobile : stylesDesktop;

    const { designSettings, settingsLoading, error } = useDesignSettingsData();
    console.log(designSettings);
    return (
        <>
            <div
                className={styles.containerBanner}
                style={designSettings?.pharosBanner ? { '--banner-image-url': `url("${designSettings.pharosBanner}")` } : undefined}
            >
                <section className={`global-section global-section-banner ${styles.section}`}>
                    <div className={`global-container ${styles.content}`}>
                        {designSettings && designSettings.pharosBanner && (
                            <img src={`${designSettings.pharosBanner}`} alt="Pharos" />
                        )}
                    </div>
                </section>
            </div>
        </>
    );
};

export default Banner;
